import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://collive.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZta2RqdGFuaWdwd2FpZGZmdXN0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDczODE3NDksImV4cCI6MjAyMjk1Nzc0OX0.WXLmBOY2MMTB6LZIJYhlXtWsPSNvDqdTbQ5QAhXqPdo";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
